
import { debugMode, SEARCH_LIMIT } from './filter-logic-config.js';

let lastLoggedResultsCount = null;
let lastLoggedResultsHash = null;

/**
 * Push the final output array into lazyLoadManager (preferred) or fileListManager.
 * When falling back to fileListManager, also calls window.updateResultsCount with hasMore flag.
 * For lazyLoadManager path, the manager itself triggers updateResultsCount.
 */
export function updateResultsDisplay(output, queryChanged) {
    // Если output.length === SEARCH_LIMIT, значит была обрезка и есть еще результаты
    const hasMoreResults = output.length === SEARCH_LIMIT;

    if (window.lazyLoadManager) {
        if (debugMode === '1' && queryChanged) {
            console.log('[SEARCH] Updating file list via lazyLoadManager.setFiles:', output.length, 'files', hasMoreResults ? '(has more)' : '');
        }
        // lazyLoadManager invokes updateResultsCount itself with the correct hasMore flag
        window.lazyLoadManager.setFiles(output);
        return;
    }

    const limited = output.slice(0, 30);
    if (window.fileListManager) {
        if (debugMode === '1' && queryChanged) {
            console.log('[SEARCH] Updating file list via fileListManager.updateFiles:', limited.length, 'files', hasMoreResults ? '(has more)' : '');
        }
        window.fileListManager.updateFiles(limited);
    }
    if (window.updateResultsCount && typeof window.updateResultsCount === 'function') {
        window.updateResultsCount(output.length, hasMoreResults);
    }
}

/**
 * Log the final result list once per (query, results) change. Deduplicates via hash.
 */
export function logFinalResults(output, queryOriginal, queryChanged) {
    const resultsHash = output.length + '|' + (output.length > 0 ? (output[0]?.id || output[0]?.n || '') : '');
    const resultsChanged = resultsHash !== lastLoggedResultsHash || queryChanged;
    if (debugMode === '1' && queryOriginal && resultsChanged) {
        console.log('[SEARCH] Results:', output.length, 'files', output.map(f => f.n || f.name || f.id || 'unknown'));
        lastLoggedResultsCount = output.length;
        lastLoggedResultsHash = resultsHash;
    }
}
